module.exports = __webpack_public_path__ + "img/1.91e3ef53.png";